import React from 'react';
import { Col, Row , FormGroup, Label, Input, Button } from 'reactstrap';
import api from '../../api';
import './index.css';

const databaseFields = [
    'name',
    'description',
    'owner_name'
]

// The Roster component matches one of two different routes
// depending on the full pathname
export default class DatabaseEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            database: {
                id: parseInt(this.props.match.params.database_id, 10) || '',
                code_name: '',
                description: '',
                name: '',
                tables: [],
            },
        }
    }
    componentWillMount() {
        this.getDatabase();
    }
    componentDidMount = () => {
    }
    updateObjectAttributes(attr, value) {
        const { database } = this.state;
        database[attr] = value;
        this.setState({ database });
    }
    getDatabase() {
        const { database } = this.state;
        let uri = `database/${database.id}`;
        api.fetchAPI({
            method: 'get',
            uri,
            success: (response) => {
                if (response.status === 'ok') {
                    const database = response.database;
                    this.setState({ database });
                }
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    updateDatabase() {
        const { database } = this.state;
        let uri = `databases`;
        console.log(database)
        api.fetchAPI({
            method: 'put',
            uri,
            body: database,
            success: (response) => {
                if (response.status === 'ok') {
                    this.props.history.push(`/database/${database.id}`);
                }
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    render() {
        const { database } = this.state;
        
        if (!database) return null;
        return (
            <div>
                <Row>
                    <Col xs={12}>
                        <h1>Edit {database.code_name}</h1>
                    </Col>
                </Row>
                <Row>
                    {databaseFields.map(field => 
                        <Col xs={12}>
                            <FormGroup>
                                <Label>{field}</Label>
                                <Input
                                    type="textarea"
                                    value={database[field]}
                                    onChange={(e) => this.updateObjectAttributes(field, e.target.value)}
                                />
                            </FormGroup>
                        </Col>    
                    )}
                    <Col xs={12}>
                        <FormGroup>
                            <Button
                                color="success"
                                onClick={() => this.updateDatabase()}
                            >
                                Save
                            </Button>
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        )
    };
}



// WEBPACK FOOTER //
// ./src/pages/DatabaseEdit/index.js